/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/12/user-white': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<g class="nc-icon-wrapper" _fill="#fff"><path pid="0" d="M9.543 6.189A4.271 4.271 0 016 8.5a4.271 4.271 0 01-3.543-2.311A5.976 5.976 0 00.138 9.726a.5.5 0 00.206.518 9.987 9.987 0 0011.312 0 .5.5 0 00.206-.518 5.976 5.976 0 00-2.319-3.537z"/><path pid="1" d="M6 0a3 3 0 00-3 3c0 1.611 1.26 4 3 4s3-2.389 3-4a3 3 0 00-3-3z" data-color="color-2"/></g>'
  }
})
